import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, ApiVersion } from 'src/app/services/api.service';
import { QuesitosModel, QuesitosModelRequest, QuestionarioResponseModel} from '../models/questionario.model';
@Injectable()
export class QuestionarioService {
  constructor(private http: HttpClient, private apiService: ApiService) { }

  salvarOpcao(
    { hashQuesito, hashOpcao, hashProfessor, hashPessoa }
  ): Observable<QuestionarioResponseModel> {
    return this.http.post<QuestionarioResponseModel>(
      `${this.apiService.getUrl()}/${ApiVersion}/quesitos/salvar-opcao`,
      {
        hashQuesito,
        hashOpcao,
        hashProfessor,
        hashPessoa
      }
    );
  }

  salvarOpcoesComentario(
    data: QuesitosModelRequest
  ): Observable<QuestionarioResponseModel> {
    return this.http.post<QuestionarioResponseModel>(
      `${this.apiService.getUrl()}/${ApiVersion}/quesitos/salvar-opcoes`, data
    );
  }


  salvarOpcaoAdicional(
    { hashPessoaAdicional, hashPessoa, hashPOAAluno, quesitos, comentario }
  ): Observable<QuestionarioResponseModel> {
    return this.http.post<QuestionarioResponseModel>(
      `${this.apiService.getUrl()}/${ApiVersion}/quesitos/salvar-opcao-adicional`,
      {
        hashPessoaAdicional,
        hashPessoa,
        hashPOAAluno,
        quesitos,
        comentario
      }
    );
  }

  SaveSemAula(
    { hashQuesito, hashProfessor, hashPessoa },
    naoPossuiAulaComProfessor: boolean
  ): Observable<QuesitosModel> {
    return this.http.post<QuesitosModel>(
      `${this.apiService.getUrl()}/${ApiVersion}/quesitos/sem-aula`,
      {
        hashQuesito,
        hashProfessor,
        hashPessoa,
        naoPossuiAulaComProfessor
      }
    );
  }

  PrefereNaoResponder(
    { hashQuesito, hashProfessor, hashPessoa },
    naoSabeAvaliarProfessor: boolean
  ): Observable<QuesitosModel> {
    return this.http.post<QuesitosModel>(
      `${this.apiService.getUrl()}/${ApiVersion}/quesitos/prefere-nao-responder`,
      {
        hashQuesito,
        hashProfessor,
        hashPessoa,
        naoSabeAvaliarProfessor
      }
    );
  }

  finalizarPOA(poaPessoaHash: string) {
    return this.http.get<any[]>(
      `${this.apiService.getUrl()}/${ApiVersion}/quesitos/${poaPessoaHash}/finalizar`
    );
  }

}
